import { t } from "ttag";

import type { FilterOperatorOption } from "metabase/querying/filters/types";
import { Button, Icon, Menu } from "metabase/ui";
import type * as Lib from "metabase-lib";

import S from "./FilterOperatorPicker.module.css";

interface FilterOperatorPickerProps<T extends Lib.FilterOperator> {
  value: T;
  options: FilterOperatorOption<T>[];
  onChange: (operator: T) => void;
}

export function FilterOperatorPicker<T extends Lib.FilterOperator>({
  value,
  options,
  onChange,
}: FilterOperatorPickerProps<T>) {
  const selectedOption = options.find((option) => option.operator === value);

  return (
    <Menu>
      <Menu.Target>
        <Button
          rightSection={<Icon name="chevrondown" />}
          aria-label={t`Filter operator`}
          className={S.root}
        >
          {selectedOption?.displayName ?? t`Select operator`}
        </Button>
      </Menu.Target>
      <Menu.Dropdown>
        {options.map((option, index) => (
          <Menu.Item key={index} onClick={() => onChange(option.operator)}>
            {option.displayName}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
}
